import SideBar from "../Navbar/Sidebar";
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import "./UserProfile.css";
import { useRef } from "react";
import instance from "../Apis/axios";
import { useLocation, useNavigate } from "react-router-dom";
import { loadeUser } from "../../action/adminAction";

Modal.setAppElement("#root");
const initialState = {
  firstname: " ",
  phonenumber: " ",
  role: "",
  password: "",
  confirmpassword: "",
};
const UserProfile = () => {
  const dispatch = useDispatch();
  const locations = useLocation();
  const path = locations.pathname;
  const [users, setUser] = useState(initialState);

  const { firstname, phonenumber, role, password, confirmpassword } = users;

  const changeHandler = (e) => {
    setUser({ ...users, [e.target.name]: e.target.value });
  };

  const { user } = useSelector((state) => state.user);

  const updateuser = async (e) => {
    e.preventDefault();
    const data = await instance.post(`admin/update?path=${path}`, {
      firstname: users.firstname,
      phonenumber: users.phonenumber,
      password: users.password,
      confirmpassword: users.confirmpassword,
    });
    
    dispatch(loadeUser());
  };

  useEffect(() => {
    setUser({ ...user[0] });
  }, []);

  const userRef = useRef(null);
  const settingRef = useRef(null);
  const userButton = useRef(null);
  const settingButton = useRef(null);

  const switchTab = (e, tab) => {
    if (tab === "users") {
      userButton.current.classList.add("navActive");
      settingButton.current.classList.remove("navActive");

      userRef.current.classList.remove("userProfileHidden");
      settingRef.current.classList.add("userProfileHidden");
    }

    if (tab === "setting") {
      userButton.current.classList.remove("navActive");
      settingButton.current.classList.add("navActive");

      userRef.current.classList.add("userProfileHidden");
      settingRef.current.classList.remove("userProfileHidden");
    }
  };

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        <div className="page-title">{/* <h4>{role}</h4> */}</div>
        <section className="page-container">
          <div className="page-container-nav">
            <ul>
              <li
                onClick={(e) => switchTab(e, "users")}
                ref={userButton}
                className={"navActive"}
              >
                <i class="fa-solid fa-bullhorn"></i> <br /> Personal Information
              </li>
              <li onClick={(e) => switchTab(e, "setting")} ref={settingButton}>
                {" "}
                <i class="fa-solid fa-gauge-high"></i> <br /> Account Settings
              </li>
            </ul>
          </div>
          <form
            onSubmit={updateuser}
            className="userProfileContainer text-center"
            ref={userRef}
          >
            <div className="userProfileDetails">
              <div>
                <label htmlFor="name">Name </label>
                <br/>
                <input
                  name="firstname"
                  className="ms-4"
                  type="text"
                  value={firstname}
                  onChange={changeHandler}
                />
              </div>

              <div>
                <label htmlFor="phone" className="text-nowrap">
                  Contect No
                </label>
                <br/>
                <input
                  name="phonenumber"
                  type="text"
                  value={phonenumber}
                  onChange={changeHandler}
                />
              </div>
              <div>
                <label htmlFor="phone" className="text-nowrap">
                  Department
                </label>
                <input name="role" type="text" value={role} disabled />
              </div>
              <br />

              <input type="submit" value="Save" />
            </div>
          </form>
          <form
            onSubmit={updateuser}
            className="userProfileContainer userProfileHidden text-center"
            ref={settingRef}
          >
            <div className="userProfileDetails">
              <div className="py-4">
                <label htmlFor="password" className="me-2">New_Password: </label>
                <input
                  name="password"
                  type="password"
                  value={password}
                  onChange={changeHandler}
                />
              </div>
              <div className="py-4">
                <label htmlFor="password" className="me-2">Confirm_Password:  </label>
                <input
                  name="confirmpassword"
                  type="password"
                  value={confirmpassword}
                  onChange={changeHandler}
                />
              </div>

              <br />

              <input type="submit" value="Update Password" />
            </div>
          </form>
        </section>
      </div>
    </div>
  );
};

export default UserProfile;
